module.exports = __webpack_public_path__ + "static/media/11.958703e5.svg";